import { Fragment } from 'react';

export default function Pageheader(props: any) {
  return (
    <Fragment>
      <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
        <h1 className="page-title fw-semibold fs-22 mb-0">{props.title}</h1>
         {props.children}
      </div>
    </Fragment>
  );
}

